
  import { Component, Vue, VModel } from "vue-property-decorator";
  import LzEditorInput from "@/components/EditorInput.vue";
  import DesignModal from "@/components/DesignModal.vue";
  import LayoutSelect from "@/components/LayoutSelect.vue";

  type WhyChooseUsProps = WebProps["whyChooseUs"];

  @Component({
    name: "WhyChooseUs",
    components: { LzEditorInput, DesignModal, LayoutSelect }
  })
  export default class WhyChooseUs extends Vue {
    @VModel() props!: WhyChooseUsProps;

    layoutOptions = [
      {
        value: "left",
        label: this.$t("common.design.layout.options.left")
      },
      {
        value: "right",
        label: this.$t("common.design.layout.options.right")
      }
    ];

    validateIfEnabled(validation: string) {
      return this.props.enabled ? validation : [];
    }
  }
